import { OrderInvoicePrinting } from './OrderInvoicePrinting';

import { orderToPrintService } from './infra';

import type { OrderIdForcedProps } from './domain';

export function ForceOrderInvoicePrinting(props: OrderIdForcedProps) {
  const { orderIdForced = NaN } = props;
  const { isRenderForced } = orderToPrintService(props);
  return (
    <>
      {isRenderForced && (
        <aside
          aria-label='ForceOrderInvoicePrinting'
          style={{
            width: '80mm',
            marginTop: '2rem',
            border: '1px solid black',
          }}
        >
          <OrderInvoicePrinting orderIdForced={orderIdForced} />
        </aside>
      )}
    </>
  );
}
